// FROM https://github.com/tmorehouse/vue-transfer-dom
// FROM https://github.com/rhyzx/vue-transfer-dom

export default {

    install: function (Vue, options) {

        const name = (options && options.name) || 'transferDom'

        // Define the directive
        Vue.directive(name, {
            inserted: function (el, bindings) {
                // default append to <body>
                const container = bindings.value
                    ? document.getElementById(bindings.value)
                    : document.body

                if (container) {
                    ( bindings.modifiers.prepend && container.firstChild )
                        ? container.insertBefore(el, container.firstChild)  // top of target
                        : container.appendChild(el)                         // bottom of target
                } else {
                    console.warn(
                        'v-' + name + ' target element id "' + bindings.arg + '" not found.'
                    )
                }
            },

            unbind: function(el) {
                if (el.parentNode != null) {
                    el.parentNode.removeChild(el);
                }
            }

        })

    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/vue-transfer-dom.js